// 日付を日本語のYYYY年M月形式に変換するhook
export const useMonthYearFormat = () => {
  const formatBirthMonth = (date: string | undefined): string => {
    if (!date) return '未選択';
    const dateObj = new Date(`${date}`);
    return `${dateObj.getFullYear()}年${dateObj.getMonth() + 1}月`;
  };

  return formatBirthMonth;
};
